import SlideshowBuilder from './SlideshowBuilder/SlideshowBuilder';

const SlideshowBuilderDirective = (
  reactDirective,
  $modal,
  $rootScope,
  CreativeService,
  OpenGraphDataService
) => {
  return reactDirective(
    SlideshowBuilder,
    undefined,
    {
      restrict: 'E'
    },
    {
      $modal,
      $rootScope,
      CreativeService,
      OpenGraphDataService
    }
  );
};

SlideshowBuilderDirective.$inject = [
  'reactDirective',
  '$modal',
  '$rootScope',
  'CreativeService',
  'OpenGraphDataService'
];

export default SlideshowBuilderDirective;
